<template>
  <v-dialog v-model="show_time_table" max-width="730px" min-width="730px">
    <v-card max-width="730px" min-width="730px">
      <v-card-title>
        <h3 class="headline">{{ labels.schedule }}</h3>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-checkbox
          :primary-title="true"
          :hide-details="true"
          class="pa-0 ma-0"
          v-model="only_node"
          :label="labels.list_check_session"
        ></v-checkbox>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text align="center">
        <table>
          <tr>
            <th></th>
            <th>
              <v-checkbox
                :hide-details="true"
                class="pa-0 ma-0"
                v-model="days_checked"
                :label="labels.monday"
                value="M"
              ></v-checkbox>
            </th>
            <th>
              <v-checkbox
                :hide-details="true"
                class="pa-0 ma-0"
                v-model="days_checked"
                :label="labels.tuesday"
                value="T"
              ></v-checkbox>
            </th>
            <th>
              <v-checkbox
                :hide-details="true"
                class="pa-0 ma-0"
                v-model="days_checked"
                :label="labels.wednesday"
                value="W"
              ></v-checkbox>
            </th>
            <th>
              <v-checkbox
                :hide-details="true"
                class="pa-0 ma-0"
                v-model="days_checked"
                :label="labels.thursday"
                value="R"
              ></v-checkbox>
            </th>
            <th>
              <v-checkbox
                :hide-details="true"
                class="pa-0 ma-0"
                v-model="days_checked"
                :label="labels.friday"
                value="F"
              ></v-checkbox>
            </th>
            <th>
              <v-checkbox
                :hide-details="true"
                class="pa-0 ma-0"
                v-model="days_checked"
                :label="labels.saturday"
                value="S"
              ></v-checkbox>
            </th>
            <th>
              <v-checkbox
                :hide-details="true"
                class="pa-0 ma-0"
                v-model="days_checked"
                :label="labels.sunday"
                value="U"
              ></v-checkbox>
            </th>
          </tr>
          <tr v-for="time in times" :key="time">
            <td>{{ time }}</td>
            <td v-for="day in days" :key="day">
              <v-checkbox
                :hide-details="true"
                class="pa-0 ma-0"
                v-model="nodes"
                :label="day + time"
                :value="day + time"
              ></v-checkbox>
            </td>
          </tr>
        </table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat v-on:click="selectAllNode">{{ labels.select_all }}</v-btn>
        <v-btn flat v-on:click="clearAllNode">{{ labels.clear }}</v-btn>
        <v-btn flat v-on:click="show_time_table = false">
          {{ labels.confirm }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import languages from "../../languages/NodeDialog.json";

export default {
  data: () => ({
    labels: {
      schedule: "",
      list_check_session: "",
      monday: "",
      tuesday: "",
      wednesday: "",
      thursday: "",
      friday: "",
      saturday: "",
      sunday: "",
      select_all: "",
      clear: "",
      confirm: "",
    },
    all_node: [],
    days_checked: [],
    days_checked_last: [],
  }),
  watch: {
    days_checked: function () {
      var temp_node = new Set(this.$store.state.nodes);

      // 差集
      let result = this.days_checked
        .filter((e) => {
          return this.days_checked_last.indexOf(e) === -1;
        })
        .concat(
          this.days_checked_last.filter((f) => {
            return this.days_checked.indexOf(f) === -1;
          })
        );

      var checked = this.days_checked.indexOf(result[0]);

      for (var time_key in this.$store.state.times) {
        var node = result + this.$store.state.times[time_key];
        if (checked != -1) {
          temp_node.add(node);
        } else {
          temp_node.delete(node);
        }
      }
      this.days_checked_last = this.days_checked;
      this.$store.commit("setNodes", Array.from(temp_node));
    },
    select_language(value) {
      this.setLanguage(value);
    },
  },
  computed: {
    days() {
      return this.$store.state.days;
    },
    times() {
      return this.$store.state.times;
    },
    nodes: {
      get() {
        return this.$store.state.nodes;
      },
      set(value) {
        this.$store.commit("setNodes", value);
      },
    },
    show_time_table: {
      get() {
        return this.$store.state.show_time_table;
      },
      set(value) {
        this.$store.commit("setShowTimeTable", value);
      },
    },
    only_node: {
      get() {
        return this.$store.state.only_node;
      },
      set(value) {
        this.$store.commit("setOnlyNode", value);
      },
    },
    select_language() {
      return this.$store.state.select_language;
    },
  },
  methods: {
    selectAllNode: function () {
      this.$store.commit("setNodes", this.all_node);
    },
    clearAllNode: function () {
      this.days_checked = [];
      this.$store.commit("setNodes", []);
    },
    setLanguage: function (select_language) {
      this.labels.schedule = languages.schedule[select_language.lang];
      this.labels.list_check_session =
        languages.list_check_session[select_language.lang];
      this.labels.monday = languages.monday[select_language.lang];
      this.labels.tuesday = languages.tuesday[select_language.lang];
      this.labels.wednesday = languages.wednesday[select_language.lang];
      this.labels.thursday = languages.thursday[select_language.lang];
      this.labels.friday = languages.friday[select_language.lang];
      this.labels.saturday = languages.saturday[select_language.lang];
      this.labels.sunday = languages.sunday[select_language.lang];
      this.labels.select_all = languages.select_all[select_language.lang];
      this.labels.clear = languages.clear[select_language.lang];
      this.labels.confirm = languages.confirm[select_language.lang];
    },
  },
  created() {
    this.$store.state.days.forEach((i) =>
      this.$store.state.times.forEach((j) => this.all_node.push(i + j))
    );
    this.days_checked = this.$store.state.days;
    this.$store.commit("setNodes", this.all_node);
    this.setLanguage(this.$store.state.select_language);
  },
};
</script>
